import { createSelector } from '@reduxjs/toolkit';

import filtersChoiceSelector from '@/features/choice/selectors/filters';

import isFiltersSelected from '../helpers/isFiltersSelected';

const isFiltersSelectedSelector = createSelector(filtersChoiceSelector, filtersChoice =>
  isFiltersSelected(filtersChoice),
);

export default isFiltersSelectedSelector;
